import React from 'react';
import PropTypes from 'prop-types';

const GoogleMap = ({ containerRef }) => (
  <div ref={containerRef} className='dln-serviceLocator__map' />
);

GoogleMap.propTypes = {
  containerRef: PropTypes.shape().isRequired,
};

export default GoogleMap;
